var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAlgeriaFlag = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300pt",
    height: "300pt",
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer-1",
    "data-name": "Countryflags.com"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,300)",
    d: "M 0 0 L 300 0 L 300 300 L 0 300 Z ",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,300)",
    d: "M 0 0 L 150 0 L 150 300 L 0 300 Z ",
    fill: "#006233"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "cp0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,300)",
    d: "M 0 0 L 300 0 L 300 300 L 0 300 Z M 108.114 150 C 108.114 183.136 134.977 210 168.115 210 C 201.252 210 228.114 183.136 228.114 150 C 228.114 116.863 201.252 90 168.115 90 C 134.977 90 108.114 116.863 108.114 150 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,150,75)",
    d: "M 0 0 C 41.421 0 75 -33.579 75 -75 C 75 -116.421 41.421 -150 0 -150 C -41.421 -150 -75 -116.421 -75 -75 C -75 -33.579 -41.421 0 0 0 ",
    fill: "#d21034"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,150,172.04199)",
    d: "M 0 0 L 25.912 8.419 L 41.926 -13.623 L 41.926 13.622 L 67.838 22.042 L 41.926 30.461 L 41.926 57.707 L 25.912 35.665 L 0 44.084 L 16.014 22.042 Z ",
    fill: "#d21034"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlgeriaFlag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/algeria-flag.bcd66f02.svg";
export { ForwardRef as ReactComponent };